import { useState } from 'react';

export default function EvidenceSection() {
  const [selectedData, setSelectedData] = useState<string | null>(null);
  const [selectedPatent, setSelectedPatent] = useState<string | null>(null);

  const evidenceData = [
    {
      id: 'depression',
      value: '69.2%',
      label: 'うつ病寛解率',
      subtitle: 'HAMD平均-11.7点改善',
      color: '#00d4ff',
      details: {
        title: 'うつ病治療VR - 国立精神・神経医療研究センター',
        metrics: [
          { label: '寛解率', before: '0%', after: '69.2%', improvement: '69.2%' },
          { label: '反応率', before: '0%', after: '84.6%', improvement: '84.6%' },
          { label: '継続率', before: '0%', after: '100%', improvement: '100%' }
        ],
        significance: 'p<0.0001',
        image: 'https://static.readdy.ai/image/9ec2f66b8d375e0bcf4643aa24e6a3e1/24e46382f20d5c83c21288e63e8041d6.jpeg'
      }
    },
    {
      id: 'training',
      value: '75%',
      label: '研修時間削減',
      subtitle: 'ハーバード医科大学共同研究',
      color: '#ff6b35',
      details: {
        title: '緩和ケア教育 - ハーバード医科大学',
        metrics: [
          { label: '教育時間', before: '4時間', after: '1時間', improvement: '75%削減' },
          { label: '必要リソース', before: '講師・俳優・施設', after: 'VRのみ', improvement: '大幅削減' }
        ],
        significance: '統計的有意差あり',
        image: 'https://static.readdy.ai/image/9ec2f66b8d375e0bcf4643aa24e6a3e1/775a8a8fa663354ce40f581d709f1124.jpeg'
      }
    },
    {
      id: 'proficiency',
      value: '2倍',
      label: '習熟度向上',
      subtitle: '救急医療教育663名で実証',
      color: '#4ade80',
      details: {
        title: '救急救命士教育 - 663名の学生で実証',
        metrics: [
          { label: 'チーム連携理解度', before: '39%', after: '80%', improvement: '2.05倍' },
          { label: '初期処置理解度', before: '47%', after: '82%', improvement: '1.74倍' }
        ],
        significance: '統計的有意差あり',
        image: 'https://readdy.ai/api/search-image?query=Large%20group%20of%20young%20Asian%20Japanese%20paramedic%20students%20all%20with%20straight%20black%20hair%20and%20typical%20Japanese%20facial%20features%20in%20professional%20training%20facility%20in%20Tokyo%20Japan%20using%20VR%20headsets%20for%20emergency%20medical%20simulation%2C%20realistic%20ambulance%20and%20emergency%20room%20training%20scenarios%20in%20Japanese%20medical%20school%20with%20Japanese%20signage%2C%20team%20coordination%20practice%20with%20multiple%20young%20Japanese%20students%20with%20black%20hair%20collaborating%20together%2C%20modern%20emergency%20medical%20services%20education%20center%20in%20Japan%20with%20advanced%20simulation%20equipment%20and%20Japanese%20professional%20instructors%20with%20black%20hair%20wearing%20white%20coats&width=1200&height=675&seq=evidence-paramedic-training-jp-v3-001&orientation=landscape'
      }
    },
    {
      id: 'interest',
      value: '135%',
      label: '神経外科への関心向上',
      subtitle: '医学生85名での実証',
      color: '#a78bfa',
      details: {
        title: '神経外科への関心 - 国際医療福祉大学',
        metrics: [
          { label: '神経外科への関心', before: '26%', after: '61%', improvement: '135%向上' },
          { label: '対象', before: '', after: '医学生85名', improvement: '2.3倍' }
        ],
        significance: 'p<0.0001',
        image: 'https://readdy.ai/api/search-image?query=Group%20of%20young%20Asian%20Japanese%20medical%20students%20all%20with%20straight%20black%20hair%20and%20typical%20Japanese%20facial%20features%20at%20modern%20Japanese%20university%20campus%20in%20Japan%20experiencing%20detailed%20neurosurgery%20VR%20simulation%20with%20brain%20surgery%20visualization%2C%20engaged%20young%20Japanese%20doctors%20with%20black%20hair%20learning%20complex%20surgical%20procedures%20in%20virtual%20reality%2C%20advanced%20medical%20education%20facility%20at%20International%20University%20of%20Health%20and%20Welfare%20in%20Japan%20with%20cutting-edge%20VR%20technology%20for%20neurosurgical%20training%2C%20professional%20healthcare%20education%20environment%20in%20Japanese%20medical%20school%20with%20Japanese%20interior%20design%20and%20Japanese%20medical%20equipment&width=1200&height=675&seq=evidence-neurosurgery-education-jp-v3-001&orientation=landscape'
      }
    },
    {
      id: 'infection',
      value: '有意差',
      label: '感染対策スキル向上',
      subtitle: 'OSCE中央値12点 vs 9点',
      color: '#10b981',
      details: {
        title: '感染対策スキル - 広島大学病院',
        metrics: [
          { label: 'OSCE実技試験', before: '講義群9点', after: 'VR群12点', improvement: '統計的有意差' },
          { label: 'トリアージ手順精度', before: '24%', after: '34%', improvement: '+40% (p=0.02)' }
        ],
        significance: 'p=0.024',
        image: 'https://static.readdy.ai/image/9ec2f66b8d375e0bcf4643aa24e6a3e1/947002ee10c9ef10f8bbcc988f54e533.jpeg'
      }
    },
    {
      id: 'triage',
      value: '29点',
      label: 'トリアージ実技向上',
      subtitle: 'VR群 vs 講義群25点',
      color: '#06b6d4',
      details: {
        title: 'トリアージ教育 - 日本体育大学・日本医科大学',
        metrics: [
          { label: '実技試験スコア', before: '講義群25点', after: 'VR群29点', improvement: '統計的有意差' },
          { label: 'トリアージ手順精度', before: '24%', after: '34%', improvement: '+40%' }
        ],
        significance: 'p=0.03',
        image: 'https://static.readdy.ai/image/9ec2f66b8d375e0bcf4643aa24e6a3e1/d29422928a62bb4ca07ce9ecb3eb2532.jpeg'
      }
    }
  ];

  const patentData = [
    {
      id: 'depression-ai',
      name: 'AI名医特許',
      region: '日米取得',
      icon: '🏆',
      color: 'from-amber-400 to-yellow-600',
      glowColor: 'rgba(251, 191, 36, 0.5)',
      patentNumbers: ['特許第7562105号', 'US Patent 12,081,810'],
      title: 'メンタル・身体状態最適化AI',
      description: '患者のバイタルに応じて最適な映像を瞬時に作曲。心拍・視線データをリアルタイム解析し、AIが「今、最も効果的な映像」を選択・配列して再生。治療結果を学習し精度を継続的に向上させる「進化するデジタル医薬」。',
      keyTech: '生体情報に基づくコンテンツ「表示順序」「再生時間」の動的生成技術。効果を学習しAIを進化させるサイクル。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20medical%20research%20facility%20interior%20with%20young%20Japanese%20patient%20with%20straight%20black%20hair%20sitting%20comfortably%20in%20ergonomic%20chair%20wearing%20VR%20headset%20for%20depression%20treatment%2C%20visible%20biometric%20sensors%20on%20wrist%20and%20chest%20with%20glowing%20blue%20LED%20indicators%2C%20large%20wall-mounted%20monitor%20displaying%20real-time%20heart%20rate%20graphs%20and%20AI%20analysis%20data%20with%20Japanese%20interface%2C%20Japanese%20medical%20researcher%20in%20white%20lab%20coat%20with%20black%20hair%20observing%20tablet%20showing%20synchronized%20patient%20vitals%2C%20calming%20nature%20therapy%20visuals%20reflected%20in%20VR%20goggles%2C%20soft%20ambient%20lighting%20in%20clean%20white%20clinical%20environment%2C%20professional%20medical%20technology%20photography%20style%2C%20emphasizing%20AI-driven%20personalized%20digital%20therapeutics&width=1200&height=675&seq=patent-depression-ai-jp-v1-001&orientation=landscape',
      results: ['うつ病寛解率 69.2%', '反応率 84.6%', '継続率 100%']
    },
    {
      id: 'skill-sync',
      name: '技能継承特許',
      region: '日本取得',
      icon: '🥋',
      color: 'from-blue-400 to-cyan-600',
      glowColor: 'rgba(59, 130, 246, 0.5)',
      patentNumbers: ['特許第7523765号'],
      title: '技能感覚完全同期システム',
      description: '熟練者の「指先の力加減」まで寸分違わず伝達。高度な技術は「見て学ぶ」だけでは習得できない。熟練者の「視界（映像）」だけでなく、対象に触れる際の「圧力（触覚）」「音」まで完全同期で記録・伝達。専用グローブで、プロが力を込める瞬間の「感覚」をリアルタイムで体験可能。',
      keyTech: '映像データ・圧力データ・音声データを遅延なく完全同期で伝送する技術。学習者の動作が一致した時のみ触覚フィードバックを伝える制御。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20medical%20training%20facility%20showing%20skill%20transfer%20technology%2C%20experienced%20Japanese%20surgeon%20with%20black%20hair%20in%20blue%20surgical%20scrubs%20wearing%20specialized%20white%20haptic%20gloves%20with%20visible%20black%20sensor%20dots%20performing%20precise%20surgical%20technique%2C%20young%20Japanese%20medical%20resident%20with%20black%20hair%20wearing%20VR%20headset%20and%20matching%20white%20haptic%20gloves%20mimicking%20exact%20hand%20movements%2C%20split%20screen%20composition%20showing%20synchronized%20hand%20positions%2C%20blue%20digital%20data%20streams%20and%20pressure%20sensor%20visualization%20connecting%20both%20participants%2C%20modern%20Japanese%20medical%20education%20center%20with%20advanced%20simulation%20equipment%2C%20professional%20medical%20technology%20photography%20emphasizing%20tactile%20feedback%20synchronization&width=1200&height=675&seq=patent-skill-sync-jp-v1-001&orientation=landscape',
      results: ['学習速度 2.05倍向上', '研修時間 75%削減']
    },
    {
      id: 'smartphone-prescription',
      name: 'スマホ処方特許',
      region: '日本取得',
      icon: '📱',
      color: 'from-purple-400 to-pink-600',
      glowColor: 'rgba(168, 85, 247, 0.5)',
      patentNumbers: ['特許第7422362号'],
      title: 'VR治療スマホ処方システム',
      description: 'QRコード1つで治療用VRを自宅へ持ち帰り。病院に高額なVR機器は不要。医師がタブレットで患者に適した治療メニューを選択しQRコードを発行。患者は自分のスマートフォンでスキャンし、すぐに自宅で治療プログラムを開始可能。場所を問わず医療用VRを広く届けるシステム。',
      keyTech: '医療施設で作成した治療メニュー（シーケンス情報）を二次元コード経由で患者デバイスに連携・提供する完結システム。',
      image: 'https://readdy.ai/api/search-image?query=Three-step%20horizontal%20workflow%20infographic%20in%20modern%20Japanese%20medical%20clinic%2C%20STEP%201%20shows%20Japanese%20doctor%20with%20black%20hair%20in%20white%20coat%20holding%20tablet%20displaying%20large%20QR%20code%20while%20Japanese%20patient%20with%20black%20hair%20scans%20with%20smartphone%2C%20STEP%202%20shows%20same%20patient%20walking%20outside%20clinic%20holding%20only%20smartphone%20with%20checkmark%20notification%2C%20STEP%203%20shows%20patient%20relaxed%20at%20home%20on%20comfortable%20sofa%20using%20simple%20cardboard%20VR%20viewer%20with%20smartphone%20for%20therapy%20session%2C%20purple%20and%20pink%20gradient%20arrows%20connecting%20each%20step%2C%20clean%20professional%20medical%20infographic%20style%2C%20emphasizing%20accessibility%20and%20convenience%20of%20smartphone-based%20VR%20therapy&width=1200&height=675&seq=patent-smartphone-prescription-jp-v1-001&orientation=landscape',
      results: ['医療機関の設備投資 85%削減', '患者アクセス性 大幅向上']
    },
    {
      id: 'learning-ai',
      name: '学習ポイント生成AI',
      region: '特許出願中',
      icon: '🧠',
      color: 'from-emerald-400 to-teal-600',
      glowColor: 'rgba(16, 185, 129, 0.5)',
      patentNumbers: ['特許出願中（出願番号 2024-220444）'],
      title: 'ラーニングポイント自動生成AI',
      description: '映像内の「学ぶべきこと」をAIが自動でテキスト化。蓄積された膨大な映像資産をAIが解析。音声や映り込んだ物体から「ここが重要」「試験に出る」を自動判定し、解説文（学習ガイド）を生成。教育コンテンツ作成の労力を劇的に削減する次世代教育AIエンジン。',
      keyTech: 'コンテンツ内のキーワードや状況を解析し、学習済みモデルを用いて「学習ポイント（解説文）」を自動生成する処理。',
      image: 'https://readdy.ai/api/search-image?query=Over-the-shoulder%20view%20of%20young%20Japanese%20medical%20student%20with%20straight%20black%20hair%20studying%20at%20modern%20desk%20in%20Japanese%20university%2C%20hands%20holding%20tablet%20displaying%20surgical%20training%20video%20with%20AI-generated%20popup%20annotations%20in%20Japanese%20text%20highlighting%20key%20learning%20points%20like%20exclamation%20mark%20important%20technique%20here%2C%20video%20timeline%20at%20bottom%20with%20multiple%20green%20AI%20markers%20indicating%20auto-generated%20learning%20points%2C%20second%20monitor%20in%20background%20showing%20AI%20analysis%20interface%20with%20Japanese%20characters%2C%20student%20taking%20notes%20with%20stylus%20pen%2C%20soft%20desk%20lamp%20lighting%2C%20clean%20modern%20educational%20technology%20photography%20style%2C%20emphasizing%20AI-powered%20automatic%20learning%20content%20generation&width=1200&height=675&seq=patent-learning-ai-jp-v1-001&orientation=landscape',
      results: ['教育コンテンツ制作速度 90%向上', '教師データ生成の自動化']
    }
  ];

  return (
    <section className="relative w-full py-32 bg-black">
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-[#00d4ff]/10 border border-[#00d4ff]/30 rounded-full mb-8">
            <i className="ri-bar-chart-line text-[#00d4ff] mr-3 text-xl"></i>
            <span className="text-[#00d4ff] font-bold text-sm tracking-wider">BACKED BY SCIENCE</span>
          </div>
          <h2 className="text-6xl font-black text-white mb-3" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
            Evidence & Proven Value
          </h2>
          <p className="text-2xl text-[#00d4ff] font-bold mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
            導入効果と信頼の証（エビデンス）
          </p>
          <p className="text-xl text-[#b0b8c1] max-w-4xl mx-auto leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
            ハーバード医科大学、国立精神・神経医療研究センターなど世界トップクラスの研究機関との共同研究により実証された、圧倒的な効果。
          </p>
        </div>

        {/* Evidence Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {evidenceData.map((item) => (
            <div
              key={item.id}
              onClick={() => setSelectedData(item.id)}
              className="relative bg-[#0a0b0d] border-2 border-gray-800 rounded-2xl p-8 text-center hover:border-[var(--color)] transition-all duration-300 hover:shadow-[0_0_40px_rgba(var(--color-rgb),0.3)] cursor-pointer group"
              style={{ '--color': item.color, '--color-rgb': item.color === '#00d4ff' ? '0,212,255' : item.color === '#ff6b35' ? '255,107,53' : item.color === '#4ade80' ? '74,222,128' : item.color === '#a78bfa' ? '167,139,250' : item.color === '#10b981' ? '16,185,129' : '6,182,212' } as React.CSSProperties}
            >
              <div className="mb-4">
                <span 
                  className="text-7xl font-black drop-shadow-[0_0_30px_rgba(var(--color-rgb),0.8)] group-hover:scale-110 transition-transform duration-300 inline-block" 
                  style={{ fontFamily: 'Noto Sans JP, sans-serif', color: item.color }}
                >
                  {item.value}
                </span>
              </div>
              <p className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                {item.label}
              </p>
              <p className="text-sm text-[#b0b8c1]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                {item.subtitle}
              </p>
              <div className="mt-4 flex items-center justify-center text-[#00d4ff] text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="mr-2">詳細を見る</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>

        {/* World-Class Institutions */}
        <div className="bg-gradient-to-br from-[#0a0b0d] to-[#1a1d23] rounded-3xl p-12 border border-gray-800 mb-32">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
              🏛️ 世界トップクラスの研究機関
            </h3>
            <p className="text-lg text-[#b0b8c1]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
              国内外の著名な医療機関との共同研究により、VR医療教育・治療の効果を実証
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { flag: '🇺🇸', name: 'ハーバード医科大学', field: '緩和ケア、救急外傷シミュレーション' },
              { flag: '🇯🇵', name: '国立精神・神経医療研究センター', field: 'うつ病デジタル治療' },
              { flag: '🇯🇵', name: '広島大学病院', field: '感染対策教育' },
              { flag: '🇯🇵', name: '国際医療福祉大学', field: '神経外科教育' },
              { flag: '🇺🇸', name: 'ジョージ・メイソン大学', field: '認知症ケア' },
              { flag: '🇯🇵', name: '日本医科大学 / 日本体育大学', field: '災害トリアージ' }
            ].map((institution, index) => (
              <div key={index} className="bg-[#0a0b0d] rounded-xl p-6 border border-gray-800 hover:border-gray-600 transition-all duration-300 hover:shadow-lg">
                <div className="flex items-start space-x-4">
                  <div className="text-3xl">{institution.flag}</div>
                  <div>
                    <h4 className="font-bold text-white mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                      {institution.name}
                    </h4>
                    <p className="text-sm text-[#b0b8c1]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                      {institution.field}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Protected IP Section */}
        <div className="mb-20">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-amber-500/10 to-yellow-500/10 border border-amber-500/30 rounded-full mb-8">
              <i className="ri-shield-star-line text-amber-400 mr-3 text-xl"></i>
              <span className="text-amber-400 font-bold text-sm tracking-wider">PROTECTED INTELLECTUAL PROPERTY</span>
            </div>
            <h2 className="text-5xl font-black text-white mb-6" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
              特許技術による資産価値
            </h2>
            <p className="text-xl text-[#b0b8c1] max-w-4xl mx-auto leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
              他社が真似できない強力な武器（Moat）。日米で取得した特許技術が、競争優位性を法的に保護します。
            </p>
          </div>

          {/* Patent Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {patentData.map((patent) => (
              <div
                key={patent.id}
                onClick={() => setSelectedPatent(patent.id)}
                className="group relative bg-gradient-to-br from-[#1a1d23] to-[#0a0b0d] rounded-2xl p-8 border-2 border-gray-700 hover:border-transparent cursor-pointer transition-all duration-500 overflow-hidden"
                style={{
                  boxShadow: `0 0 0 0 ${patent.glowColor}`
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = `0 0 60px 10px ${patent.glowColor}`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = `0 0 0 0 ${patent.glowColor}`;
                }}
              >
                {/* Metallic Shine Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Patent Certificate Icon */}
                <div className={`relative mb-6 w-20 h-20 mx-auto rounded-2xl bg-gradient-to-br ${patent.color} flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-2xl`}>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent rounded-2xl"></div>
                  <span className="text-4xl relative z-10">{patent.icon}</span>
                  {/* Metallic Border */}
                  <div className="absolute inset-0 rounded-2xl border-2 border-white/20"></div>
                </div>

                {/* Patent Name */}
                <h3 className="text-2xl font-black text-white mb-2 text-center group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-amber-300 group-hover:to-yellow-500 transition-all duration-300" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                  {patent.name}
                </h3>

                {/* Region Badge */}
                <div className={`inline-flex items-center px-4 py-2 rounded-full text-xs font-bold text-white bg-gradient-to-r ${patent.color} mx-auto mb-4 shadow-lg`}>
                  <i className="ri-global-line mr-2"></i>
                  {patent.region}
                </div>

                {/* Patent Numbers - Hidden by default, shown on hover */}
                <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 mt-4 space-y-2">
                  {patent.patentNumbers.map((num, idx) => (
                    <div key={idx} className="text-xs text-[#b0b8c1] text-center font-mono bg-black/30 rounded-lg py-2 px-3 border border-gray-700">
                      {num}
                    </div>
                  ))}
                </div>

                {/* Click to view details */}
                <div className="mt-6 flex items-center justify-center text-amber-400 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="mr-2">詳細を見る</span>
                  <i className="ri-arrow-right-line"></i>
                </div>

                {/* Corner Decoration */}
                <div className="absolute top-0 right-0 w-16 h-16 opacity-20">
                  <div className={`absolute top-2 right-2 w-12 h-12 bg-gradient-to-br ${patent.color} rounded-full blur-xl`}></div>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Info */}
          <div className="mt-12 text-center">
            <p className="text-sm text-[#b0b8c1] max-w-3xl mx-auto" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
              💡 これらの特許技術により、競合他社は同様のシステムを構築することが法的に制限されます。<br />
              実証されたエビデンスと特許による保護が、持続的な競争優位性を生み出します。
            </p>
          </div>
        </div>
      </div>

      {/* Evidence Detail Popup */}
      {selectedData && (
        <div 
          className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-8"
          onClick={() => setSelectedData(null)}
        >
          <div 
            className="bg-[#0a0b0d] border-2 border-[#00d4ff] rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {evidenceData.filter(item => item.id === selectedData).map((item) => (
              <div key={item.id} className="p-12">
                <div className="flex justify-between items-start mb-8">
                  <h3 className="text-3xl font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    {item.details.title}
                  </h3>
                  <button 
                    onClick={() => setSelectedData(null)}
                    className="w-10 h-10 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    <i className="ri-close-line text-3xl"></i>
                  </button>
                </div>

                <div className="mb-8">
                  <img 
                    src={item.details.image} 
                    alt={item.details.title}
                    className="w-full h-80 object-cover object-top rounded-2xl border-2 border-gray-700"
                    onError={(e) => {
                      console.error('Image failed to load:', item.details.image);
                      e.currentTarget.style.backgroundColor = '#1a1d23';
                    }}
                  />
                </div>

                <div className="space-y-6">
                  {item.details.metrics.map((metric, index) => (
                    <div key={index} className="bg-[#1a1d23] rounded-2xl p-6 border border-gray-800">
                      <div className="flex justify-between items-center mb-4">
                        <span className="text-lg font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                          {metric.label}
                        </span>
                        <span 
                          className="px-4 py-2 rounded-full text-sm font-bold text-white"
                          style={{ backgroundColor: item.color }}
                        >
                          {metric.improvement}
                        </span>
                      </div>
                      {metric.before && (
                        <div className="flex items-center space-x-4 text-sm">
                          <span className="text-gray-400">Before: {metric.before}</span>
                          <i className="ri-arrow-right-line text-[#00d4ff]"></i>
                          <span className="text-white font-medium">After: {metric.after}</span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <div className="mt-8 text-center">
                  <span 
                    className="inline-block px-6 py-3 rounded-full text-sm font-bold text-white"
                    style={{ backgroundColor: item.color }}
                  >
                    統計的有意差: {item.details.significance}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Patent Detail Popup */}
      {selectedPatent && (
        <div 
          className="fixed inset-0 bg-black/95 backdrop-blur-md z-50 flex items-center justify-center p-8"
          onClick={() => setSelectedPatent(null)}
        >
          <div 
            className="bg-gradient-to-br from-[#1a1d23] to-[#0a0b0d] border-2 border-amber-500/50 rounded-3xl max-w-5xl w-full max-h-[90vh] overflow-y-auto shadow-[0_0_80px_rgba(251,191,36,0.3)]"
            onClick={(e) => e.stopPropagation()}
          >
            {patentData.filter(item => item.id === selectedPatent).map((patent) => (
              <div key={patent.id} className="p-12">
                {/* Header */}
                <div className="flex justify-between items-start mb-8">
                  <div className="flex items-center gap-6">
                    <div className={`w-24 h-24 rounded-2xl bg-gradient-to-br ${patent.color} flex items-center justify-center shadow-2xl`}>
                      <span className="text-5xl">{patent.icon}</span>
                    </div>
                    <div>
                      <h3 className="text-4xl font-black text-white mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                        {patent.name}
                      </h3>
                      <div className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-bold text-white bg-gradient-to-r ${patent.color}`}>
                        <i className="ri-global-line mr-2"></i>
                        {patent.region}
                      </div>
                    </div>
                  </div>
                  <button 
                    onClick={() => setSelectedPatent(null)}
                    className="w-12 h-12 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer rounded-full hover:bg-white/10"
                  >
                    <i className="ri-close-line text-3xl"></i>
                  </button>
                </div>

                {/* Patent Numbers */}
                <div className="mb-8 bg-black/40 rounded-2xl p-6 border border-gray-700">
                  <h4 className="text-sm font-bold text-amber-400 mb-3 flex items-center">
                    <i className="ri-file-shield-line mr-2"></i>
                    特許番号
                  </h4>
                  <div className="space-y-2">
                    {patent.patentNumbers.map((num, idx) => (
                      <div key={idx} className="text-lg text-white font-mono bg-black/30 rounded-lg py-3 px-4 border border-gray-800">
                        {num}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Image */}
                <div className="mb-8">
                  <img 
                    src={patent.image} 
                    alt={patent.title}
                    className="w-full h-80 object-cover object-top rounded-2xl border-2 border-gray-700"
                    onError={(e) => {
                      console.error('Patent image failed to load:', patent.image);
                      e.currentTarget.style.backgroundColor = '#1a1d23';
                    }}
                  />
                </div>

                {/* Title */}
                <h4 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                  {patent.title}
                </h4>

                {/* Description */}
                <div className="bg-[#0a0b0d] rounded-2xl p-8 border border-gray-800 mb-6">
                  <h5 className="text-lg font-bold text-amber-400 mb-4 flex items-center">
                    <i className="ri-lightbulb-line mr-2"></i>
                    技術概要
                  </h5>
                  <p className="text-base text-[#b0b8c1] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    {patent.description}
                  </p>
                </div>

                {/* Key Technology */}
                <div className="bg-gradient-to-br from-amber-500/10 to-yellow-500/10 rounded-2xl p-8 border border-amber-500/30 mb-8">
                  <h5 className="text-lg font-bold text-amber-400 mb-4 flex items-center">
                    <i className="ri-key-line mr-2"></i>
                    排他的権利の核心
                  </h5>
                  <p className="text-base text-white leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    {patent.keyTech}
                  </p>
                </div>

                {/* Results */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {patent.results.map((result, idx) => (
                    <div key={idx} className={`bg-gradient-to-br ${patent.color} rounded-xl p-6 text-white shadow-xl`}>
                      <div className="flex items-center gap-3">
                        <i className="ri-checkbox-circle-fill text-3xl"></i>
                        <span className="text-lg font-bold" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                          {result}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Link to VR Impact */}
      <div className="mt-20 text-center">
        <a
          href="https://jollygood.co.jp/vrimpact/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/50 text-cyan-400 rounded-lg hover:from-cyan-500/30 hover:to-blue-500/30 hover:border-cyan-400 transition-all duration-300 cursor-pointer whitespace-nowrap group"
        >
          <span className="font-bold">研究データと特許情報の詳細を見る</span>
          <i className="ri-external-link-line text-xl group-hover:translate-x-1 transition-transform"></i>
        </a>
        <p className="text-gray-500 text-sm mt-3">※ 別タブで開きます（VR Impactページへ）</p>
      </div>
    </section>
  );
}
